module.exports = __webpack_public_path__ + "img/tv-blue.c4d16cc9.svg";